import { IDataItem, IPieChartData } from "./interfaces";
import { IEventWithHours } from "components/HMIUptimeDowntimeBar/HMIUptimeDowntimeBarInterfaces";
import { truncateLongText } from "utilities/utilities";
import { translateDefaultEntity } from "utilities/localesUtilities";
import { DefaultTranslationFieldsInTable } from "constants/constants";
import { roundToMinutes } from "../downtimeSlideUtils";

export const buildPieChartData = (
    downtimeEvents: IEventWithHours[] | undefined,
    displayUnit: string,
    language: string,
): IDataItem[] => {
    const groupedData: IPieChartData[] = [];

    downtimeEvents?.forEach((obj) => {
        const translatedName = translateDefaultEntity(
            language,
            obj.failure_type,
            "name",
            DefaultTranslationFieldsInTable.FAILURE_TYPE,
        );

        const existingItem = groupedData.find((item) => item[translatedName]);

        if (!existingItem) {
            groupedData.push({
                [translatedName]: {
                    id: truncateLongText(translatedName, 25),
                    name: truncateLongText(translatedName, 25),
                    value: displayUnit === "minutes" ? obj.validTime : 1,
                    color: obj.failure_type.color_code,
                },
            });
        } else {
            existingItem[translatedName].value += displayUnit === "minutes" ? obj.validTime : 1;
        }
    });

    if (displayUnit === "minutes") {
        groupedData.forEach((item) => {
            const entry = Object.values(item)[0];
            entry.value = roundToMinutes(entry.value);
        });
    }

    return groupedData.flatMap((item) => Object.values(item));
};

export const hasOnlyNaNValues = (data: IDataItem[]): boolean =>
    data.length > 0 && data.every((item) => isNaN(item.value));
